var _defs, _rect, _circle, _g, _path, _g2, _use, _use2, _use3, _path2, _g3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComfort2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140mm",
    height: "140mm",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4",
    x1: 74.348,
    x2: 74.348,
    y1: 81.624,
    y2: 77.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0687ff",
    offset: 0.96865
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e80000",
    stopOpacity: 0,
    offset: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 36.288,
    width: 5.8308,
    height: 23.648,
    fill: "#e80000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.115,
    cy: 51.104,
    r: 13.229,
    fill: "#e80000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.115,
    cy: 51.104,
    r: 10.583
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.115 61.688v25.316l5.2917 13.229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.115 87.004-5.2917 13.924v15.528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.406 100.54v15.875"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64.823 44.49-1.7772 4.7398-1e-3 0.0016a2.0929 2.0929 0 0 0-0.28681 0.76584 2.0929 2.0929 0 0 0-5.1e-4 0.0015l-0.0274 0.07235h0.0186a2.0929 2.0929 0 0 0-0.0186 0.26355 2.0929 2.0929 0 0 0 2.0929 2.0929 2.0929 2.0929 0 0 0 2.0929-2.0929 2.0929 2.0929 0 0 0-0.0181-0.26355h0.0181l-0.0269-0.07131v-1e-3a2.0929 2.0929 0 0 0-0.28836-0.76894l-5.1e-4 -5.17e-4z",
    fill: "#08f",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e80000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m113.77 58.349v20.896a7.6146 7.6146 0 0 0-3.7528 6.5624 7.6146 7.6146 0 0 0 7.615 7.6145 7.6146 7.6146 0 0 0 7.6145-7.6145 7.6146 7.6146 0 0 0-3.5393-6.4322v-21.026z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.06,
    y: 47.625,
    width: 0.86814,
    height: 4.0771e-8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#f00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m123.03 42.333 5.2917 5.2917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.45 42.333-5.2917 5.2917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.22 37.042 7.4835 4e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.26 37.042-7.4835-4e-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.74 29.558 1e-5 -7.4835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.03 31.75 5.2917-5.2917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.45 31.75-5.2917-5.2917"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m70.115 68.302 12.114-5.6146",
    fill: "#e80000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(85.112 82.229 62.688)",
    xlinkHref: "#path32"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(205.39 74.952 73.447)",
    xlinkHref: "#path32"
  })), /*#__PURE__*/React.createElement("g", null, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-36.736 84.626 83.737)",
    strokeWidth: 1.5,
    xlinkHref: "#path32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.396 116.42s3.5073-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916",
    fill: "none",
    stroke: "#f00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m72.885 75.754 0.79667 7.4644h1.9917l1.195-7.4644z",
    fill: "url(#linearGradient4)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    style: {
      mixBlendMode: "normal"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.979 116.42s3.5073-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.563 116.42s3.5073-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.667 116.42s3.5073-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.896 116.42s3.5074-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.57 116.39s3.5074-5.394 0-9.6916c-4.1236-5.0527 0-9.6916 0-9.6916"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.198 118.74h111.13v0",
    fill: "#e80000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfort2);
export default __webpack_public_path__ + "static/media/comfort2.f2414ff47cf3a23d428678da5cb5dda7.svg";
export { ForwardRef as ReactComponent };